import React from 'react';
import Paper from '@mui/material/Paper';
import CircleIcon from '@mui/icons-material/Circle';
import { useGetColors } from '../../api/hooks/inventory';
import Table from '../common/table';

export default function ColorsTable() {
  const { data: colors } = useGetColors();

  return (
    <Paper variant="outlined" sx={{ width: '100%' }}>
      <Table columns={columns} rows={colors} />
    </Paper>
  );
}

const columns = [
  {
    id: 'name',
    label: 'نام مدل',
    minWidth: 170,
  },
  {
    id: 'rgb',
    label: 'نمایش',
    minWidth: 40,
    format: (code) => <CircleIcon sx={{ color: code, fontSize: '14px' }} />,
  },
];
